import React from 'react';

interface ValidationAlertProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

const ValidationAlert: React.FC<ValidationAlertProps> = ({
  isOpen,
  message,
  onClose
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Modal Backdrop */}
      <div 
        className="modal fade show d-block" 
        style={{ backgroundColor: 'rgba(220, 53, 69, 0.2)' }}
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content border-0 shadow" style={{ borderRadius: '15px', border: '2px solid #dc3545' }}>
            {/* Modal Header */}
            <div className="modal-header bg-transparent border-0 p-3 pb-0">
              <div className="w-100 text-center position-relative">
                {/* Close Button */}
                <button
                  type="button"
                  className="btn-close position-absolute"
                  style={{ top: '-5px', right: '-5px' }}
                  onClick={onClose}
                  aria-label="Close"
                ></button>
                
                <div className="mb-2">
                  <div 
                    className="rounded-circle d-inline-flex align-items-center justify-content-center"
                    style={{ 
                      width: '48px', 
                      height: '48px', 
                      backgroundColor: '#dc3545',
                      color: '#ffffff'
                    }}
                  >
                    <i className="fas fa-exclamation fs-5"></i>
                  </div>
                </div>
                <h6 className="modal-title fw-bold text-danger mb-0">
                  Required Fields Missing
                </h6>
              </div>
            </div>

            {/* Modal Body */}
            <div className="modal-body p-3 pt-1">
              <div className="text-center mb-3">
                <p className="text-dark mb-3 small">
                  {message}
                </p>
              </div>

              {/* Action Button */}
              <div className="d-grid">
                <button
                  type="button"
                  className="btn btn-danger"
                  style={{ borderRadius: '10px' }}
                  onClick={onClose}
                >
                  <i className="fas fa-check me-2"></i>
                  Got It
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ValidationAlert;